import { Facebook, Instagram, Linkedin } from "lucide-react";
import { scrollToId } from "../../lib/scroll";
import { CONTACT, SOCIALS } from "../../lib/assets";

const FOOTER_SOCIALS = [
  { icon: Facebook, href: SOCIALS.facebook, label: "Facebook" },
  { icon: Instagram, href: SOCIALS.instagram, label: "Instagram" },
  { icon: Linkedin, href: SOCIALS.linkedin, label: "LinkedIn" },
];

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-2 gap-10 items-start">
          <div>
            <div className="flex items-center gap-2">
              <span className="h-2.5 w-2.5 rounded-full bg-teal-400" />
              <span className="font-display text-2xl font-extrabold tracking-tight">NOMAN ZAHEER</span>
            </div>
            <p className="mt-4 font-display text-3xl md:text-4xl font-bold tracking-tight text-teal-300 leading-tight max-w-md">
              A Fresh Voice For Our Schools
            </p>
            <p className="mt-4 text-slate-400">
              School Trustee Candidate<br />
              Pembina Trails School Division
            </p>
          </div>

          <div className="md:text-right">
            <a href="https://votezaheer.ca" className="font-display text-2xl font-extrabold tracking-tight border-b-2 border-teal-400">
              {CONTACT.website}
            </a>
            <div className="mt-5 flex md:justify-end gap-3">
              {FOOTER_SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="h-10 w-10 inline-flex items-center justify-center rounded-full border border-white/20 text-white/80 hover:bg-white hover:text-slate-900 transition-colors"
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                >
                  <s.icon size={18} />
                </a>
              ))}
            </div>
            <button
              onClick={() => scrollToId("#join")}
              className="mt-6 rounded-full bg-teal-600 text-white font-semibold px-6 py-3 hover:bg-teal-500 transition-colors"
              data-testid="footer-join-button"
            >
              Join The Campaign
            </button>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between text-sm text-slate-400">
          <p>© {new Date().getFullYear()} Noman Zaheer Campaign. All rights reserved.</p>
          <p>{CONTACT.phone} · {CONTACT.email}</p>
        </div>
      </div>
    </footer>
  );
};
